export const GET_USER = "GET_USER";
export const BLOCK_UNBLOCK_SWITCH = "BLOCK_UNBLOCK_SWITCH";
export const GET_BLOCKED_USER = "GET_BLOCKED_USER";

export const GET_HISTORY = "GET_HISTORY";

export const EDIT_COIN = "EDIT_COIN";
export const EDIT_UID = "EDIT_UID";

export const UPDATE_USER = "UPDATE_USER";
